/**
 * PWA entry point.
 * Registers service worker and mounts the React app.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { useServiceWorker } from './hooks/useServiceWorker';
import './styles/index.css';
import './styles/responsive.css';

function Root() {
  useServiceWorker();
  return <App />;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
